import React from 'react'

import { 
    Box, Paper, Button, Typography,
    Card, CardHeader, 
    CardContent, CardMedia, Avatar,  
} from '@mui/material'

import { capitalizeWords } from '../../services/utils'
import { toast } from 'react-toastify'
import Modal from '../../Components/Modal'

import { useNavigate } from 'react-router-dom'
import { usePatient } from 'Components/usePatientContext'

const imageDoctor = `${process.env.PUBLIC_URL}/static/media/medico.png`

export function CardItem({ nome, data, horarios }) {

    const [ open  , setOpen   ] = React.useState(false)

    const [ modal , setModal  ] = React.useState({title: 'Confirmar o agendamento?', description: ''})

    const { 
        patient, 
        setAgenda, 
        setLoading,
        handleConfirmSchedule,
        setModalFallback,   
        setOpenFallback
    } = usePatient()

    const navigate = useNavigate()

    const handleClose = () => {
        setOpen(false)
        setLoading(true)
        navigate("/central-agendamento")
    }


    const onSelect = item => {
        const nome = patient?.nomePaciente ? patient?.nomePaciente : patient?.nomePessoa
        setAgenda(item)
        setModal( prevState => ({ ...prevState, 
            hideImportant: true,
            description: <>

                <Typography 
                    variant={'p'} 
                    component={'p'} 
                
                >Nome do Paciente: {capitalizeWords(nome)}</Typography>
                <Typography 
                    variant={'p'} 
                    component={'p'} 
                
                >Convênio: {capitalizeWords(patient.descricaoConvenio)}</Typography>
                <Typography 
                    variant={'p'} 
                    component={'p'} 
                
                >Médico(a): {capitalizeWords(item.nomeProfissional)}</Typography>
                <Typography 
                    variant={'p'} 
                    component={'p'} 
                
                >Especialidade: {capitalizeWords(patient.descricaoEspecialidade)}</Typography>
                <Typography
                    variant={'p'} 
                    component={'p'} 
                >Data e hora: {item.dataAgenda} - {item.horarioAgenda}h</Typography>
            </>
        }))

        setOpen(true)       
        
    }

    const handleConfirm = async () => {
        
        try {
            
            setOpen(false)

            setLoading(true)
            
            await handleConfirmSchedule()

            toast.success('Agendamento feito com sucesso')
            
            navigate('/obrigado', { replace: true })

        } catch (error) {
            setOpenFallback(true) 
            setModalFallback( { 
                hideImportant       : true,
                title               : "Central de Agendamento",
                description         : "Favor entrar em contato com a Central.",
                disableCancel       : true,
                disableEscapeKeyDown: true,
                labelConfirm        : "Ok",
                redirect            : "/central-agendamento", 
                handleConfirm: () => { setOpenFallback(false)  }
            })
            
            toast.error('Ocorreu um erro ao fazer o agendamento')

        } finally {
            setLoading(false)
        }
    }

    
    
    return (
        <>
            <Modal sx={{ display: 'none' }} open={open} handleClose={handleClose} handleConfirm={handleConfirm} {...modal} />
            <Card 
                elevation={3} 
                sx={{ 
                    bgcolor: 'white', 
                    flex: { md: '0 0 370px'} 
                }} 
                component={Paper} 
            >
                <Box>
                    <CardHeader
                        sx={{
                            py: 2,
                            display: 'grid',
                            gridTemplateColumns: { md: '1fr 4fr', xs: '1fr 3fr' },
                            gap: 2,
                            
                        }} 
                        titleTypographyProps={{textAlign: 'center'}}
                        subheaderTypographyProps={{textAlign: 'center'}}
                        avatar={
                            <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                
                                <Avatar sx={{ bgcolor: 'white', border: '1px solid #ccc' }} aria-label="médico">
                                    <CardMedia
                                        component="img"
                                        alt="Ícone do médico"
                                        height="40"
                                        width="40"
                                        image={imageDoctor}
                                    />
                                </Avatar>
                            
                                <Typography py={1} variant={'caption'} component={'blockquote'}>
                                    {data}
                                </Typography> 
                                
                            </Box>
                        }
                        title={nome}
                        subheader={patient.descricaoEspecialidade}
                        
                    />
                </Box>
                <Box>
                    <CardContent sx={{overflowY: 'auto', display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr 1fr 1fr' } }}>
                        
                        { horarios?.map( (item, index) => { 
                            //<>{horario}<Typography variant='p' textTransform={'lowercase'}>h</Typography></>
                            const horario = item.horarioAgenda 
                            return <Button 
                                onClick={() => onSelect(item)}
                                component={Paper} 
                                sx={{color: 'rgb(28 28 28)'}}
                                key={index} 
                                id={item.idAgenda}
                                children={horario} />
                            })
                        }
                    </CardContent>
                </Box>
            </Card>
        </>
    )
}